import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import AdminEmailView from '../components/views/admin/AdminEmailView';
import { SkeletonAdminBody } from '../components/Skeleton';

function AdminEmailPage() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          navigate('/login');
          return;
        }

        const res = await api.get('/auth/me');
        // /auth/me returns user object directly, not wrapped in data.user
        const userData = res?.data;

        if (!userData || !userData._id) {
          navigate('/login');
          return;
        }

        // Check if user is admin
        if (userData.role !== 'A') {
          navigate('/dashboard');
          return;
        }

        // Check if user is locked
        if (userData.locked) {
          navigate('/locked');
          return;
        }

        setUser(userData);
      } catch (error) {
        console.error('Error fetching user:', error);
        navigate('/login');
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100">
        <SkeletonAdminBody form />
      </div>
    );
  }

  if (!user) {
    return null;
  }

  return <AdminEmailView user={user} />;
}

export default AdminEmailPage;

